export default __webpack_public_path__ + "static/media/garage10.e1650238.jpg";